<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/uniq_final_packing_list/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-boxes"></i><span class="space-icon"></span>
      {{ $t("labels.packages_from_stock_title") }}
    </h1>

    <div class="mt-4 flex flex-row">
      <div class="panel-plain-label">
        <badge-default :label="`${getFormatNumber(total_packages)} ${$t(
          'labels.total_packages_from_stock'
        )}`" />
      </div>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue style="height: 600px" class="ag-theme-alpine" @grid-ready="onGridReady" :columnDefs="columnDefs"
        :defaultColDef="defaultColDef" :rowData="packages_from_stock">
      </ag-grid-vue>
    </div>

    <table-paginator v-model="current_page" v-if="Number(total_packages) > 0" :total_rows="total_packages"
      :rows_per_page="rowsPerPage.packages_from_stock">
    </table-paginator>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import { dateFilter } from "@/components/views/mixins/ag_grid_filters.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "PHProductionBasicContainerExportShowProcessPackagesFromStock",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      current_page: this.currentPage.packages_from_stock,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      columnDefs: [
        {
          headerName: this.$t("model.package.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          width: 50
        },
        {
          headerName: this.$t("model.package.registered_at"),
          valueGetter: params => {
            return params.data.registered_at;
          },
          valueFormatter: params => {
            return this.dateFormatter(params.data.registered_at);
          },
          filter: "agDateColumnFilter",
          filterParams: dateFilter
        },
        {
          headerName: this.$t("model.package.producer"),
          field: "producer.fullname"
        },
        {
          headerName: this.$t("model.package.exported_batch"),
          field: "exported_batch.batch_code"
        },
        {
          headerName: this.$t("model.package.quantity"),
          field: "quantity",
          filter: "agNumberColumnFilter",
          width: 150
        },
        {
          headerName: this.$t("model.package.exporter_process_crop_package"),
          field: "exporter_process_crop_package.label"
        },
        {
          headerName: this.$t("model.package.exporter_process_brand"),
          field: "exporter_process_brand.agro_exporter_brand.name"
        }
      ]
    };
  },
  props: {
    packages_from_stock: { type: Array, default: () => [] },
    packing_house_id: {},
    packing_house_process_id: {},
    currentPage: { type: Object, default: () => { return { packages_from_stock: 1 } } },
    rowsPerPage: { type: Object, default: () => { return { packages_from_stock: 12 } } },
    stats: { type: Object, default: () => { return { packages_from_stock: { total: null } } } }
  },
  computed: {
    total_packages() {
      return this.stats?.packages_from_stock?.total || 0;
    }
  },
  watch: {
    current_page: function (newvalue) {
      let current_page = this.currentPage;
      current_page.packages_from_stock = newvalue;
      this.$emit('update:currentPage', current_page)
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    }
  }
};
</script>
